import * as React from "react";
const SvgUploadClose = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={50}
    fill="none"
    {...props}
  >
    <path
      fill="#6366F1"
      d="M50 1c-3.9 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7m2.7 10.5L50 8.8l-2.7 2.7-.8-.8L49.2 8l-2.7-2.7.8-.8L50 7.2l2.7-2.7.8.8L50.8 8l2.7 2.7zM11.719 3.125a3.906 3.906 0 0 0-3.906 3.906V42.97a3.91 3.91 0 0 0 3.906 3.906H38.28a3.91 3.91 0 0 0 3.907-3.906V26.563a7.813 7.813 0 0 0-7.813-7.813h-3.906a3.906 3.906 0 0 1-3.907-3.906v-3.906a7.813 7.813 0 0 0-7.812-7.813z"
    />
    <path
      fill="#6366F1"
      d="M27.023 3.783a10.9 10.9 0 0 1 2.665 7.154v3.907c0 .43.35.78.78.78h3.907a10.9 10.9 0 0 1 7.154 2.665A20.35 20.35 0 0 0 27.023 3.784"
    />
  </svg>
);
export default SvgUploadClose;